import { useState, useEffect, CSSProperties } from 'react';
import Loader from 'elements/Loader'
import PostCreationInfoView from './PostCreationInfoView';
import { ScheduleOptions, EmailCampaignData } from 'modules/Types';
import { EmailTemplateData } from 'api/campaignApi';
import { useHistory } from 'react-router';
import useMessageYourFans from 'Hooks/useMessageYourFans';
import { clsx } from 'modules/Utils';
import { marketingPageSty } from 'pages/MarketingPage/styles';
import { styx } from 'modules/Utils';

enum PostCreationStatus {
    FINALIZING = 'FINALIZING',
    MESSAGE_SENT = 'MESSAGE_SENT',
    MESSAGE_SCHEDULED = 'MESSAGE_SCHEDULED',
    MESSAGE_YOUR_FANS = 'MESSAGE_YOUR_FANS',
    ERROR = 'ERROR',
}

const { FINALIZING, MESSAGE_SCHEDULED, MESSAGE_SENT, ERROR } =
    PostCreationStatus;

const { ASAP, SCHEDULED } = ScheduleOptions;

interface PostCreationProps {
    className?: string;
    style?: CSSProperties;
    handleViewStatus: (status: PostCreationStatus) => void;
}

const PostCreation = ({
    className,
    style,
    handleViewStatus,
}: PostCreationProps) => {
    const history = useHistory();
    const {
        sendEmailTemplateData,
        design,
        details,
        getFinalHtmlContent
    } = useMessageYourFans();

    const { subjectLine, emailTemplate } = design;
    const { fans, scheduled, date, timezone } = details;

    const [isEmailsLoading, setIsEmailsLoading] = useState<boolean>(true);
    const [error, setError] = useState({ message: '', isError: false });
    const [emailCampaignData, setEmailCampaignData] = useState<EmailCampaignData | null>(null);

    const { message, isError } = error;

    const messageStatus = scheduled === SCHEDULED ? 'scheduled' : 'sent';
    const showSuccessView = !isEmailsLoading && !isError;
    const showErrorView = !isEmailsLoading && isError;
    const html_content = (emailTemplate as string).replace('70%', '90%');


    const emailTemplateDataToPost: EmailTemplateData = {
        asap: scheduled === ASAP,
        content: {
            html_content: getFinalHtmlContent(),
            subject_line: subjectLine,
        },
        date: {
            release_date: date?.utc().format(),
            timezone: timezone?.value ?? undefined,
        },
        email_fanbase: {
            // targets: fans.map(({ email }) => email as string),
            targets: ['ronughoshal@gmail.com', 'ronesh85@gmail.com', 'megh@symphony.to', 'conner@symphony.to'],
            sentTo: fans.length,
        },
    };

    const sendEmailTemplateData_local = async () => {
        try {
            setIsEmailsLoading(true);
            const response = await sendEmailTemplateData(emailTemplateDataToPost);
            const viewStatus = scheduled === SCHEDULED
                ? MESSAGE_SCHEDULED
                : MESSAGE_SENT;
            handleViewStatus(viewStatus);
            setEmailCampaignData(response);
        } catch (error) {
            console.error('Error sending email template data:', error);
            throw error;
        } finally {
            setIsEmailsLoading(false);
        };
    }

    const handleGoToCampaignDetails = () => {
        if (emailCampaignData?.id) {
            history.push(`/fans/campaigns/${emailCampaignData.id}`);
        }
    };

    const handleTryAgain = async () => {
        setError({ message: '', isError: false });
        setIsEmailsLoading(true);
        sendEmailTemplateData_local();
    };

    useEffect(() => {
        sendEmailTemplateData_local();
    }, []);

    useEffect(() => {
        if (isEmailsLoading) handleViewStatus(FINALIZING);
    }, [isEmailsLoading]);

    return (
        <div
            className={clsx('postCreationContainer', className)}
            style={styx(marketingPageSty.container, style)}
        >
            {isEmailsLoading &&
                <Loader className="postCreationLoadingContainer" size={44} isCentered />
            }
            {showSuccessView &&
                <PostCreationInfoView
                    title={`Your message has been ${messageStatus}!`}
                    description="Check the campaign details to see who's opened."
                    handleClick={handleGoToCampaignDetails}
                />
            }
            {showErrorView &&
                <PostCreationInfoView
                    title="There was an error setting up your campaign."
                    error={isError}
                    description={message}
                    handleClick={handleTryAgain}
                    buttonLabel="Try again"
                />
            }
        </div>
    );
};

export default PostCreation;
